import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import styles from '../Form.scss';
import { GlobalNotifications, Intent } from '../../../Modules';

const FormRendererControls = ({ readOnly, allChangesSaved, updateResponse }) => (
  <div style={{ textAlign: 'right', marginBottom: '2em' }}>
    {!readOnly && allChangesSaved &&
      <span className={styles.changesSaved}>All Changes Saved</span>
    }
    {readOnly &&
      <span>
        <span className={styles.changesSaved}>Your answers won&apos;t be saved</span>
        <Button primary disabled content='Save' />
      </span>
    }
    {!readOnly &&
      <Button
        primary
        disabled={allChangesSaved}
        content='Save'
        onClick={() => updateResponse(
          () => GlobalNotifications.show({
            message: 'Successfully saved form',
            intent: Intent.SUCCESS
          })
        )}
      />
    }
  </div>
);

FormRendererControls.propTypes = {
  allChangesSaved: PropTypes.bool,
  readOnly: PropTypes.bool,
  updateResponse: PropTypes.func
};

export default FormRendererControls;



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Controls.js